export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13590.509fc623.jpg";